import { type Dispatch, type SetStateAction, useState } from 'react';

/** Whether a card is open: closed while it has no rows, opened when the first arrives, otherwise as the user left it. */
// @ai-generated 2026-10-15T12:08:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function useOpensOnFirstRow(rowCount: number): [boolean, Dispatch<SetStateAction<boolean>>] {
    const hasRows = rowCount > 0;
    const [opened, setOpened] = useState(hasRows);
    const [hadRows, setHadRows] = useState(hasRows);

    if (hasRows !== hadRows) {
        setHadRows(hasRows);
        setOpened(hasRows);
    }

    return [opened, setOpened];
}
